<template>
  <div>
    <div class="common-box border-t0">
      <el-row class="row-one">
        <span class="row-one-title">分红方式变更</span>
        <Reback class="row-one-fr" @click.native="rebackOne"></Reback>
      </el-row>
      <div class="bonusModeChange" v-show="stepDisplay == '1'">
        <div style="width:775px;margin:20px auto;">
          <p class="tips" style="color:#ED0000;">你确认要进行以下变更分红方式的操作吗？</p>
          <el-form :model="tableForm1" class="table-normal-form">
            <table class="table-normal-one margin-t15" cellspacing="0">
              <tbody>
                <tr>
                  <td style="width:146px;">基金名称</td>
                  <td><span class="aColor">{{'['+singleMessage.fundcode+']'+singleMessage.fundcodename}}</span></td>
                </tr>
                <tr>
                  <td>交易账户</td>
                  <td>
                    {{bankList.channelname+'[' + bankList.depositacctByConfusion+']'}}
                  </td>
                </tr>

                <tr>
                  <td>当前分红方式</td>
                  <td><span class="rColor">{{singleMessage.dividendmethod == 1? '现金分红':'红利再投'}}</span></td>
                </tr>
                <tr>
                  <td>变更后的分红方式</td>
                  <td>
                    <el-select v-model="tableForm1.type">
                      <el-option label="红利再投" :value="0"></el-option>
                      <el-option label="现金分红" :value="1"></el-option>
                    </el-select>
                  </td>
                </tr>

              </tbody>
            </table>
          </el-form>
        </div>
        <div class="btnCenter">
          <el-button type="normal" @click="setBonusMethod">确认</el-button>
          <el-button type="cancel" class="fr" @click="rebackOne">返回</el-button>
        </div>
      </div>
      <!-- 第二步 -->
      <div class="bonusModeChange" v-show="stepDisplay == '2'">
        <div style="width:775px;margin:20px auto;">
          <p class="tips" style="color:#ED0000;">您的变更分红方式申请已受理</p>
          <el-form :model="tableForm1" class="table-normal-form">
            <table class="table-normal-one margin-t15" cellspacing="0">
              <tbody>
                <tr>
                  <td style="width:146px;">申请单号</td>
                  <td><span class="aColor">{{successMessage.appsheetserialno}}</span></td>
                </tr>
                <tr>
                  <td style="width:146px;">基金名称</td>
                  <td><span class="aColor">{{'['+singleMessage.fundcode+']'+singleMessage.fundcodename}}</span></td>
                </tr>
                <tr>
                  <td style="width:146px;">银行卡号</td>
                  <td><span class="aColor">{{bankList.depositacct}}</span></td>
                </tr>
                <tr>
                  <td style="width:146px;">当前分红方式</td>
                  <td><span class="aColor">{{singleMessage.dividendmethod == 1? '现金分红':'红利再投'}}</span></td>
                </tr>
                <tr>
                  <td style="width:146px;">更改后的分红方式</td>
                  <td><span class="aColor">{{tableForm1.type == 1? '现金分红':'红利再投'}}</span></td>
                </tr>
              </tbody>
            </table>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      stepDisplay: '1',
      card: '交易账号1',
      bonusWay: '红利再投',
      tableForm1: {
        price: '',
        pwd: '',
        zhouqi: '',
        type: 0,
      },
      bankList: {},
      // 未成年入参
      transactorname: '',
      transactorcerttype: '',
      transactorcertno: '',
      successMessage: '',
    }
  },
  created () {
    this.singleMessage = this.$route.params.message
    // console.log(this.singleMessage);
  },
  mounted () {
    this.getData()
    this.getCardList()
  },
  methods: {
    onSubmit () {
      this.stepDisplay = '2'
    },
    rebackOne () {
      this.$router.push({
        name: 'fundHoldDetails',
        params: {
          message: this.singleMessage
        }
      })
    },
    // 全局数据
    getData () {
      this.$http.post(this.$apiPath.sessionId, {
        sessionId: this.$commonJs.getCookie('sessionid'),
      }).then(res => {
        if (res.status !== 200 && res.data.code !== '200') return
        const userResult = res.data.data.custInfo
        this.transactorname = userResult.transactorname == null ? '' : userResult.transactorname
        this.transactorcerttype = userResult.transactorcerttype == null ? '' : userResult.transactorcerttype
        this.transactorcertno = userResult.transactorcertno == null ? '' : userResult.transactorcertno
      }).catch(error => { })
    },
    // 分红设置
    setBonusMethod () {
      if (this.singleMessage.dividendmethod == this.tableForm1.type) {
        this.$message.error('您更改后的分红方式与当前分红方式一致，请重新选择')
      } else {
        this.$http.post(this.$apiPath.setDefdividendMethod, {
          sessionId: this.$commonJs.getCookie('sessionid'),
          fundcode: this.singleMessage.fundcode,//
          tpasswd: '111111',
          branchcode: '308',
          transactionaccountid: this.singleMessage.transactionaccountid,//
          dividendmethod: this.tableForm1.type,//
          ratio: '1',
          transactorname: this.transactorname,
          transactorcerttype: this.transactorcerttype,
          transactorcertno: this.transactorcertno,
        }).then(res => {
          if (res.status !== 200 && res.data.code !== '200') return
          this.successMessage = res.data.data.setDividendMethodMsg[0]
          this.stepDisplay = '2'
        }).catch(err => { })
      }
    },
    getCardList () {
      this.$http.post(this.$apiPath.myBankList, {
        custno: this.$commonJs.getCookie('u_custno1'),
      }).then(res => {
        if(res.data.code == 200) {
          res.data.data.forEach(item => {
            if (item.channelid == this.singleMessage.channelid) {
              this.bankList = item
            }
          })
        }
      }).catch(err => { })
    },
  }
}
</script>

<style lang="less" scoped>
.bonusModeChange {
  width: 770px;
  margin: 0 auto;
  .tips {
    color: #ed0000;
    margin: 23px 0 18px 0;
  }
  .btnCenter {
    margin-top: 40px;
    margin-bottom: 55px;
    margin-left: 53%;
    transform: translateX(-50%);
  }
}
</style>